import React, { useEffect, useState } from 'react';
import { QueryClientProvider } from 'react-query';

import queryClient, { hydrateQueryClientStateWithDataFromLocalForage } from 'services/queryClient';

const CustomQueryClientProvider: React.FC = ({ children }) => {
  const [hasHydrated, setHydrated] = useState(false);

  useEffect(() => {
    const hydrateQueryClient = async () => {
      await hydrateQueryClientStateWithDataFromLocalForage();
      setHydrated(true);
    };

    hydrateQueryClient();
  }, []);

  return <QueryClientProvider client={queryClient}>{hasHydrated && children}</QueryClientProvider>;
};

export default CustomQueryClientProvider;
